import { AspBillCreditNotesRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspBillCreditNotes() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  // Called per vendor when a payable dialog opens — callers keep the result.
  async function fetchAspBillCreditNotes(params: AspBillCreditNotesRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspBillCreditNotes(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAspBillCreditNotes };
}
